export const appsAppGroupIdChartsKakao = "/apps/:app_group_id/charts/kakao";
